import React from "react";
import { MenuItem, Stack, TextField } from "@mui/material";

export default function AnswerFields({
  questions,
  answers,
  onChange,
  disabled,
  errors = [],
  renderEvidence,
}) {
  return (
    <Stack spacing={3}>
      {questions.map((q) => (
        <Stack key={q.id} spacing={1}>
          <TextField
            key={q.id}
            label={q.label}
            required={q.required}
            disabled={disabled}
            select={q.kind === "choice"}
            type={q.kind === "number" ? "number" : "text"}
            multiline={q.kind === "text"}
            minRows={q.kind === "text" ? 2 : undefined}
            value={answers[q.id] ?? ""}
            error={errors.some((e) => e.question_id === q.id)}
            helperText={errors.find((e) => e.question_id === q.id)?.message}
            onChange={(e) => {
              const value = e.target.value;
              onChange({
                ...answers,
                [q.id]:
                  q.kind === "number" && value !== "" ? Number(value) : value,
              });
            }}
          >
            {q.kind === "choice"
              ? [
                  <MenuItem key="empty" value="">
                    Choose…
                  </MenuItem>,
                  ...q.options.map((o) => (
                    <MenuItem key={o} value={o}>
                      {o}
                    </MenuItem>
                  )),
                ]
              : null}
          </TextField>
          {renderEvidence ? (
            renderEvidence(q)
          ) : q.photo_required ? (
            <span>
              Photo required on real assignments. Preview checks answers only.
            </span>
          ) : null}
        </Stack>
      ))}
    </Stack>
  );
}
